/* eslint-disable @typescript-eslint/naming-convention */
const AI_API_ACCESS_TOKEN = 'g856e8vlpz54g7gr84fekiwpams48z54';

export { AI_API_ACCESS_TOKEN };
